import { NavigationBarWrapper } from './navigation_bar';

export default NavigationBarWrapper;
